export default __webpack_public_path__ + "static/media/nor.97429d33.jpg";